<template>
  <header class="site-header">
    <div class="container">
      <router-link to="/" class="brand" aria-label="Ten Factor Growth home">
        <img src="images/mylogo.png" alt="">
        <span>Ten Factor Growth</span>
      </router-link>

      <button class="menu-toggle" type="button" aria-label="Toggle navigation"
              :aria-expanded="String(open)" @click.stop="open = !open">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      </button>

      <ul class="nav" :class="{ open }" ref="nav">
        <li><router-link to="/" exact>Home</router-link></li>
        <li><router-link to="/about">About</router-link></li>
        <li><router-link to="/services">Services</router-link></li>
        <li ref="customers">
          <button class="link" type="button" aria-haspopup="true"
                  :aria-expanded="String(customersOpen)"
                  @click.stop="customersOpen = !customersOpen">Customers &#9662;</button>
          <ul class="submenu" v-if="customersOpen">
            <li v-for="i in industries" :key="i.path">
              <router-link :to="i.path">{{ i.menu }}</router-link>
            </li>
          </ul>
        </li>
        <li><router-link to="/projects">Projects</router-link></li>
        <li><router-link to="/contact" class="cta-link">Contact</router-link></li>
      </ul>
    </div>
  </header>
</template>

<script>
import industries from '@/data/industries'

export default {
    name: 'SiteHeader',
    data() {
        return { industries, open: false, customersOpen: false }
    },
    watch: {
        // any navigation closes the menus, including to the page already shown
        $route() { this.close() }
    },
    methods: {
        close() {
            this.open = false
            this.customersOpen = false
        },
        documentClick(e) {
            // a click outside the Customers item closes it; links inside navigate first
            const holder = this.$refs.customers
            if (this.customersOpen && holder && !holder.contains(e.target)) {
                this.customersOpen = false
            }
            if (e.target.closest && e.target.closest('.nav a')) {
                this.close()
            }
        },
        onKey(e) {
            if (e.key === 'Escape') this.close()
        }
    },
    mounted() {
        document.addEventListener('click', this.documentClick)
        document.addEventListener('keydown', this.onKey)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.documentClick)
        document.removeEventListener('keydown', this.onKey)
    }
}
</script>
